module.exports = __webpack_public_path__ + "static/media/headphones.0f63e6c0.svg";